import moment from "moment";

// The API sends ISO dates, the profile endpoints send DD/MM/YYYY. Strict parsing
// so an unexpected value renders empty instead of "Invalid date".
const API_DATE_FORMATS = [moment.ISO_8601, "DD/MM/YYYY"];

export function formatApiDate(
  value: string | null | undefined,
  format: string
): string {
  // eslint-disable-next-line
  const parsed = moment(value ?? "", API_DATE_FORMATS as any, true);
  return parsed.isValid() ? parsed.format(format) : "";
}
